import Axios from "axios";
import { myStore } from ".";
import { handleInvalidToken } from "./store/reducers/tokenReducer";

// Environment URLs configuration
const ENV_URLS = {
  development: "https://backend-dev.alphacapitalgroup.uk",
  production: "https://backend.alphacapitalgroup.uk",
  uat: "https://backend-uat.alphacapitalgroup.uk",
  qa: "https://backend-qa.alphacapitalgroup.uk",
  legacy: "http://13.41.109.19", // Keeping for reference
  dev: "https://backend-dev.alphacapitalgroup.uk",
};

// Determine the base URL dynamically based on hostname
export const baseUrl = (() => {
  const { hostname } = window.location;

  // Development environments
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    console.log("Running in local development environment");
    return ENV_URLS.development;
  }

  // UAT environment
  if (hostname === "user-uat.alphacapitalgroup.uk") {
    console.log("Running in UAT environment");
    return ENV_URLS.qa;
  }

  // QA environment
  if (hostname === "user-dev.alphacapitalgroup.uk") {
    console.log("Running in QA environment");
    return ENV_URLS.production;
  }

  // Production environment
  console.log("Running in production environment");
  return ENV_URLS.production;
})();

// Set Axios default base URL
Axios.defaults.baseURL = baseUrl;

// Create a new Axios instance for interceptors
export const axiosInstance = Axios.create({
  baseURL: baseUrl,
  timeout: 30000, // 30 seconds timeout
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

let refreshPromise = null;
const clearRefreshPromise = () => (refreshPromise = null);

// Log the current environment and base URL
console.log(`Current environment: ${window.location.hostname}`);
console.log(`Base URL: ${baseUrl}`);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // If idToken expired, get a fresh token and process the request
    if (
      error.response?.status === 401 &&
      error.response?.data?.detail === "invalid-auth-token" &&
      !originalRequest._retry
    ) {
      const { getState, dispatch } = myStore;
      originalRequest._retry = true;

      try {
        if (!refreshPromise) {
          refreshPromise = dispatch(handleInvalidToken())
            .then((token) => {
              return token;
            })
            .catch((error) => {
              console.error("Token refresh failed:", error);
              return Promise.reject(error);
            })
            .finally(clearRefreshPromise);
        }

        const token = await refreshPromise;
        originalRequest.headers.Authorization = token;
        return axiosInstance(originalRequest);
      } catch (error) {
        console.error("Request failed after token refresh:", error);
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);
